import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { useNavigate } from 'react-router-dom';
import { Modal, Button, Tabs } from 'antd';
import './Offer.css';

const { TabPane } = Tabs;

function Daily() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentImage, setCurrentImage] = useState('');
  const [currentProductId, setCurrentProductId] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      const q = query(collection(db, 'products'));
      const querySnapshot = await getDocs(q);
      const categoriesSet = new Set();
      querySnapshot.forEach((doc) => {
        const { category } = doc.data();
        if (category) categoriesSet.add(category);
      });
      setCategories([...categoriesSet]);
    };

    fetchCategories();
    fetchProducts(); // Fetch all products without sorting by timestamp
  }, []);

  const fetchProducts = async (category = null) => {
    const q = category
      ? query(collection(db, 'products'), where('category', '==', category))
      : query(collection(db, 'products'));
    const querySnapshot = await getDocs(q);
    const productsData = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setProducts(productsData);
  };

  const calculateDiscountedPrice = (price, discount) => {
    return price - (price * discount) / 100;
  };

  const handleImageClick = (productId, imageUrl) => {
    setCurrentImage(imageUrl);
    setCurrentProductId(productId);
    setIsModalVisible(true);
  };

  const handleProductClick = (productId) => {
    navigate(`/product-details/${productId}`);
  };

  const handleOk = () => {
    navigate(`/product-details/${currentProductId}`);
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="off-container">
      <h2 className="off-title" style={{ color: 'orange' }}>Exclusive Products</h2>
      <h2 className="off-title">Dollar Furniture's</h2>

      <Tabs
        defaultActiveKey="all"
        onChange={(key) => fetchProducts(key === 'all' ? null : key)}
        style={{ marginBottom: '16px' }}
      >
        <TabPane tab="All" key="all"></TabPane>
        {categories.map((category) => (
          <TabPane tab={category} key={category}></TabPane>
        ))}
      </Tabs>

      <div className="offe-scroller">
        {products.map((product) => {
          const newPrice = calculateDiscountedPrice(product.price, product.discount);
          return (
            <div
              className="off-card"
              key={product.id}
              onClick={() => handleProductClick(product.id)}
            >
              <img
                src={product.image}
                alt={product.title}
                className="off-image"
                onClick={(e) => {
                  e.stopPropagation();
                  handleImageClick(product.id, product.image);
                }}
              />
              <div className="off-info">
                <h3 className="off-title">{product.title}</h3>
                <p className="off-price">
                  <span className="original-price">Ksh. {product.price}</span>
                  <span className="new-price"> Ksh. {newPrice.toFixed(2)}</span>
                </p>
                <p className="off-discount">{product.discount}% Off</p>
              </div>
            </div>
          );
        })}
      </div>

      <Modal
        title="Product Image"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleOk}>
            View Details
          </Button>,
        ]}
      >
        <img src={currentImage} alt="Product" style={{ width: '100%', height: 'auto' }} />
      </Modal>
    </div>
  );
}

export default Daily;
